<template>
  <div>
    <div v-if="url" class="h5player" :id="videoID"></div>
    <div v-if="!url" :style="{height: height}">
      <el-empty :image-size="80" description="无视频接入"></el-empty>
    </div>
  </div>
</template>

<script>
  import {guid} from "../util/string.util"
  import $http from '../request';

  export default {
    props: {
      id: {
        type: String,
        default: '',
      },
      url: {
        type: String,
        default: '',
      },
      startToPlay: {
        type: Boolean,
        default: false,
      },
      height: {
        type: String,
        default: '200px',
      }
    },
    data() {
      return {
        videoID: "",
        player: null,
        playUrl: null
      };
    },
    watch: {
      url(val) {
        this.$nextTick(() => {
          if (this.url && this.id) {
            this.getPreviewURLs();
          }
        });
      }
    },
    created(){
      this.videoID = "vid" + guid().substring(0, 20);

    },
    mounted() {
      this.player = new window.JSPlugin({
        szId: this.videoID,
        szBasePath: "./static/h5player",
        iMaxSplit: 1,
        iWidth: "100%",
        iHeight: this.height,
        openDebug: true,
        iCurrentSplit: 1 ,
        oStyle: {
          borderSelect: '#000',
        }
      });


      this.$nextTick(() => {
        if (this.url && this.id) {
          this.getPreviewURLs();
        }
      });
    },
    methods: {
      getPreviewURLs(){
        $http({
          url: this.url + "hikvision/camera/previewURLs",
          method: 'get',
          params: {
            cameraIndexCode: this.id
          }
        }).then((res) => {
          this.playUrl = res.data.url;
          if (this.startToPlay) {
            setTimeout(()=>{
              this.startPlay(this.playUrl);
            }, 200)
          }
        })
      },
      startPlay(url) {
        let index = this.player.currentWindowIndex;
        console.log(index);
        this.player.JS_Play(url, { playURL: url, mode: 1 }, index).then(
          () => {
              console.log('realplay success')
          },
          error => {
              console.error(error)
          }
        )
      }
    },
    destroyed() {
      if (this.player) {
        this.player.JS_Stop().then(
          () => {
              console.log('stop realplay success')
          },
          e => {
              console.error(e)
          }
        )
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/video/H5PlayerVideo.vue